import classNames from 'classnames';
import useHideBodyScroll from 'hooks/useHideBodyScroll';
import { FC } from 'react';

type PropTypes = {
  className?: string;
  isLoading?: boolean;
  isGlobal?: boolean;
};

const Loader: FC<PropTypes> = ({ className, isLoading, isGlobal }) => {
  useHideBodyScroll(!!isLoading);

  if (!isLoading) return null;

  return (
    <div
      className={classNames('loader', className, {
        'is-global-loader': isGlobal,
      })}
    >
      {Array.from({ length: 5 }).map((_, index) => (
        <span key={index} className="loader-dot"></span>
      ))}
    </div>
  );
};

export default Loader;
